import _ from 'lodash';

const rts = {
  handleInit_qAndA: 'handleInit_qAndA',
  handleSetQuestionsAndAnswers: 'handleSetQuestionsAndAnswers',
  handleSet_activeQuestions: 'handleSet_activeQuestions',
  handleSet_currentGroupedQuestions: 'handleSet_currentGroupedQuestions',
  handleSet_currentQandA: 'handleSet_currentQandA',
  handleSet_currentQuestions: 'handleSet_currentQuestions',
  handlesShow_itemQuestions: 'handlesShow_itemQuestions',
}

export const _collectionName = '_questionsAndAnswers'

export const questionsAndAnswersReducer = (state, action) => {

  const { type } = action

  switch (type) {

    // sets the data after the handleInit_qAndA call
    case rts.handleSetQuestionsAndAnswers:
      const _active = _.filter(action.qas, { questionActive: true })
      return { ...state, questionsAndAnswers: action.qas, questionsAndAnswersActive: _active }

    case rts.handleSet_activeQuestions:
      return { ...state }

    case rts.handleSet_currentGroupedQuestions:
      return { ...state }

    case rts.handleSet_currentQandA:
      return { ...state }

    case rts.handleSet_currentQuestions:
      return { ...state }

    default:
      return { ...state }
  }
}

export const questionsAndAnswersInitialState = (initState) => {
  return { ...initState }
};

export const questionsAndAnswersHandlers = (dispatch) => {
  return {
    handleInit_qAndA: () => { dispatch({ type: rts.handleInit_qAndA, dispatch }) },
    handleSetQuestionsAndAnswers: (qas) => { dispatch({ type: rts.handleSetQuestionsAndAnswers, dispatch, qas }) },
    handleUpdateQandA: (viewItem_key, itemKey, name, data, callback) => { dispatch({ type: rts.handleUpdateQandA, dispatch, viewItem_key, itemKey, name, data, callback }) },
    handleSet_activeQuestions: () => { dispatch({ type: rts.handleSet_activeQuestions, dispatch }) },
    handleSet_currentGroupedQuestions: () => { dispatch({ type: rts.handleSet_currentGroupedQuestions, dispatch }) },
    handleSet_currentQandA: () => { dispatch({ type: rts.handleSet_currentQandA, dispatch }) },
    handleSet_currentQuestions: () => { dispatch({ type: rts.handleSet_currentQuestions, dispatch }) },
  }
}

export const questionsAndAnswerEffects = () => {
  return {
    updateQandA: (viewItem_key, itemKey, name, data, callback) => updateQandA(viewItem_key, itemKey, name, data, callback),
  }
}
